import React from 'react';
import type { ReactNode } from 'react';
import type { StyleProp, ViewStyle } from 'react-native';
import { StyleSheet, Text, View } from './rn';
import HeaderBackButton from './HeaderBackButton';
import ScreenHeader from './ScreenHeader';
import { fontSize, spacing } from '../theme';
import { useTheme } from '../theme/ThemeContext';

type Props = {
  title: string;
  onBack: () => void;
  action?: ReactNode;
  contentStyle?: StyleProp<ViewStyle>;
  /** İçerik başlığın altından geçsin (7.14 · D-550). Sayfa tepede aynı
   *  yüksekliği `screenHeaderContentInset` ile geri vermek zorunda. */
  floating?: boolean;
  /** Ekranlar kendi geri kontrolünü sınayabilsin diye geri düğmesine geçirilir. */
  backTestID?: string;
};

// Secondary pages share one title, gap and navigation geometry. Descriptions
// belong in the scrollable page body, not in this fixed-height navigation row.
export default function PageHeader({ title, onBack, action, contentStyle, floating, backTestID }: Props) {
  const colors = useTheme();
  return (
    <ScreenHeader floating={floating} contentStyle={[styles.content, contentStyle]}>
      <HeaderBackButton onPress={onBack} plain={floating} testID={backTestID} />
      <Text
        testID="page-header-title"
        style={[styles.title, { color: colors.black }]}
        accessibilityRole="header"
        accessibilityLabel={title}
        numberOfLines={1}
        ellipsizeMode="tail"
        adjustsFontSizeToFit
        minimumFontScale={0.85}>
        {title}
      </Text>
      {action ? <View style={styles.action}>{action}</View> : null}
    </ScreenHeader>
  );
}

const styles = StyleSheet.create({
  content: { gap: spacing.sm },
  title: {
    flex: 1,
    minWidth: 0,
    fontSize: fontSize.md,
    fontWeight: '600',
    textAlign: 'left',
  },
  action: { flexShrink: 0 },
});
